import type { Fragment } from '../translations';

export const gouvernance: Fragment = {
  fr: {
    'gov.tab.pending': 'File d\'attente',
    'gov.tab.byFunction': 'Par fonction',
    'gov.tab.byOwner': 'Par responsable',
    'gov.tab.inventory': 'Inventaire officiel',
    'gov.headline': '{n} en attente · délai moyen {avg} j',
    'gov.headlineOver': '{n} au-delà de 14 j',
    'gov.waitingSince': 'en attente depuis {n} j',
    'gov.examine': 'examiner',
    'gov.validate': 'Valider',
    'gov.validateBlocked': 'Cases manquantes : {missing}',
    'gov.sendBack': 'Renvoyer au CdE',
    'gov.sendBackMotif': 'Motif du renvoi (obligatoire)',
    'gov.emptyQueue': 'Rien n\'attend la gouvernance.',
    'gov.emptyQueueCta': 'Voir l\'inventaire officiel ({n} processus)',
    'gov.queueError': 'La file n\'a pas pu être chargée.',
    'gov.check.roles': 'Rôles et responsabilités définis',
    'gov.check.kpis': 'KPIs clairs',
    'gov.check.dashboards': 'Dashboards de gouvernance clairs',
    'gov.check.inventory': 'Ajouté à l\'inventaire',
    'gov.fn.count': '{n} processus · {live} en service · {cycle} en cycle',
    'gov.fn.undeclared': 'Apparaît aussi comme couloir dans {n} diagrammes non déclarés',
    'gov.fn.declare': 'Déclarer cette fonction',
    'gov.fn.empty': 'Aucune fonction définie. Les fonctions se créent dans Administration → Personnes & fonctions.',
    'gov.owner.load': 'Charge déclarée {pct} %',
    'gov.owner.noCapacity': 'capacité non renseignée',
    'gov.owner.alsoLanes': 'Apparaît en outre dans {n} diagrammes sans en être responsable',
    'gov.owner.overloaded': 'surcharge',
    'gov.inv.title': 'Inventaire officiel',
    'gov.inv.since': 'Entré le {date}',
    'gov.inv.empty': 'Aucun processus dans l\'inventaire officiel pour l\'instant.',
    'gov.inv.print': 'Version imprimable',
  },
  en: {
    'gov.tab.pending': 'Queue',
    'gov.tab.byFunction': 'By function',
    'gov.tab.byOwner': 'By owner',
    'gov.tab.inventory': 'Official inventory',
    'gov.headline': '{n} waiting · average {avg} d',
    'gov.headlineOver': '{n} beyond 14 d',
    'gov.waitingSince': 'waiting for {n} d',
    'gov.examine': 'examine',
    'gov.validate': 'Approve',
    'gov.validateBlocked': 'Missing checks: {missing}',
    'gov.sendBack': 'Send back to the CdE',
    'gov.sendBackMotif': 'Reason (required)',
    'gov.emptyQueue': 'Nothing awaits governance.',
    'gov.emptyQueueCta': 'See the official inventory ({n} processes)',
    'gov.queueError': 'The queue could not be loaded.',
    'gov.check.roles': 'Roles and responsibilities defined',
    'gov.check.kpis': 'KPIs are clear',
    'gov.check.dashboards': 'Governance dashboards are clear',
    'gov.check.inventory': 'Added to the inventory',
    'gov.fn.count': '{n} processes · {live} live · {cycle} in cycle',
    'gov.fn.undeclared': 'Also appears as a lane in {n} undeclared diagrams',
    'gov.fn.declare': 'Declare this function',
    'gov.fn.empty': 'No functions defined. Functions are created in Administration → People & functions.',
    'gov.owner.load': 'Declared load {pct} %',
    'gov.owner.noCapacity': 'capacity not filled in',
    'gov.owner.alsoLanes': 'Also appears in {n} diagrams without owning them',
    'gov.owner.overloaded': 'overloaded',
    'gov.inv.title': 'Official inventory',
    'gov.inv.since': 'Entered {date}',
    'gov.inv.empty': 'No process in the official inventory yet.',
    'gov.inv.print': 'Printable version',
  },
};
